import { render, staticRenderFns } from "./sourceManagement.vue?vue&type=template&id=32b09db2&scoped=true"
import script from "./sourceManagement.vue?vue&type=script&lang=js"
export * from "./sourceManagement.vue?vue&type=script&lang=js"
import style0 from "./sourceManagement.vue?vue&type=style&index=0&id=32b09db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b09db2",
  null
  
)

export default component.exports